import { ChangeDetectionStrategy, Component, signal, computed, ViewChild } from '@angular/core';
import { FlowManagementService } from "../services/flow-management.service";
import { Flow } from "../obj/Flow";

@Component({
    selector: 'app-flows.request',
    templateUrl: './flows.request.component.html',
    styleUrl: './flows.request.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FlowsRequestComponent {
  apiRoot: string = "https://flow.microsoft.com";

  constructor(private flowManagementService: FlowManagementService) {

  }
  
  loading = signal(false);  
  environments = signal<any[]>([]);
  environment_current = signal<any>(0);
  flows = signal<Flow[]>([]);
  @ViewChild('grid', {static: true}) grid;

  flows_http_request = computed(()=> {
    return (this.flows() || []).filter( (flow: Flow) => {
      return ((flow.triggerKind === 'Http' || flow.triggerKind == 'TeamsWebhook') && flow.trigger === 'Request');
    });
  });
  flow_http_current = signal<any>(0);

  async load() {
    

    this.loading.set(true);
    try {
      const environments = await this.flowManagementService.getEnvironments().toPromise();
      this.environments.set(environments?.value);

      let all = []
      for(let i=0; i<environments?.value?.length; i++) {
        const env = environments.value[i];
        this.environment_current.set(i+1);

        const flows = await this.flowManagementService.getFlows(env.name, false, true, false, false, true);
        all.push(flows);

      }
      this.flows.set(all.flat());

      for(let j=0; j<this.flows_http_request().length; j++) {

        const flow = this.flows_http_request()[j];
        this.flow_http_current.set(j+1);

        if(!flow.definition) {
          try {
            const f1 = await this.flowManagementService.getFlow(flow.environment, flow.name).toPromise();
            flow.definition = f1?.properties?.definition;   
          } 
          catch(ex) {
            console.error("Error loading flow details for flow", flow, ex);
          }
        }

        if(!flow.triggerUrl) {
          try {
            const triggerUrl = await this.flowManagementService.getFlowTriggerUrl(flow.environment, flow.name, false);
            flow.triggerUrl = triggerUrl;
          } 
          catch(ex) {
            console.error("Error loading flow details for flow", flow, ex);
          }
        }
        if(!flow.deprecatedTriggerUrl) {
          try {
            const deprecatedTriggerUrl = await this.flowManagementService.getFlowTriggerUrl(flow.environment, flow.name, true);
            flow.deprecatedTriggerUrl = deprecatedTriggerUrl;
          }
          catch(ex) {
            console.error("Error loading flow details for flow", flow, ex);
          }
        }

        const runs = await this.flowManagementService.getFlowRuns(flow, false, false, false, 0, true);
        
        flow.runs = runs;

        if (runs && runs.length > 0) {
          const lastRun = runs[0];
          const outputs = await this.flowManagementService.getFlowRunTrigger(runs[0], true);

          const [response] = outputs || [];
          if (response && response.headers) {
            if (response.headers['x-ms-ppapi-forwarded-api-version'] || response.headers['x-ms-igw-external-uri']) {
              flow.lastRunTriggerUrlChecked = true;
            }
            else {
              flow.lastRunTriggerUrlChecked = false;
            }

            const flowName = response.headers['x-ms-workflow-name']
            if (flowName) {
              const resourcegroup:string = response.headers['x-ms-workflow-resourcegroup-name'] || '';
              const runid = response.headers['x-ms-workflow-run-id'];
              const operation = response.headers['x-ms-workflow-operation-name'] || '';

              if (resourcegroup) {
                const part1 = resourcegroup.split('-', 1)[0];
                const hex = part1.replace(/[^0-9a-fA-F]/g, '');
                const formatted = `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`.toLowerCase();

                const env = this.environments().find( (e) => e.id.toLowerCase().endsWith(formatted) );
                if (env) {
                  const callerFlow = this.flows().find( (f) => f.name === flowName && f.environment === env.name);
                  if (callerFlow) {
                    if (runid) {
                      flow.lastRunTriggerCaller = `https://flow.microsoft.com/manage/environments/${callerFlow.environment}/flows/${callerFlow.sharingType=='Coauthor'?'shared/':''}${callerFlow.flowName}/runs/${runid}`;
                    }
                    else {
                      flow.lastRunTriggerCaller = `https://flow.microsoft.com${flow.portalUrl}`;
                    }
                    continue;
                  }
                }
              }
              flow.lastRunTriggerCaller = `Flow: ${flowName}; Run: ${runid}; RG: ${resourcegroup}; Op: ${operation}`;
            }
            const referer = response.headers['Referer'] || response.headers['referer'];
            if (referer) {
              flow.lastRunTriggerCaller = `Referer: ${referer}`;
            }
          }
        }
      }

    } finally {
      this.loading.set(false);
    }

  }

  downloadCsv() {
    /*
    const rows = [];
    rows.push(['Environment', 'Flow Name', 'Flow Id', 'Trigger Type', 'Trigger Kind', 'Trigger URL', 'Deprecated Trigger URL', 'Runs Count']);  
    for(const flow of this.flows_http_request()) {
      rows.push([
        this.environments().find( (env) => env.name === flow.environment )?.displayName,
        flow.displayName,
        flow.name,
        flow.flowState,
        flow.triggerKind,
        flow.triggerUrl,
        flow.deprecatedTriggerUrl,
        flow.runsEstimateText 
      ]);
    }
    const csvContent = "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "flows_http_request_report.csv");
    document.body.appendChild(link); // Required for FF 
    link.click(); // This will download the data file named "flows_http_request_report.csv".
    document.body.removeChild(link);  
    */

    this.grid.saveAsExcel();

  }
}
